export const config = {
  dataWarehouse: {
    local: 'https://localhost:7254',
    development: 'https://devgulfdatawarehouse01.azurewebsites.net',
    production: 'https://gulfdatawarehouse01.azurewebsites.net',
  },
  emailTemplate: {
    local: '192489',
    development: '192489',
    staging: '192489',
    production: '192485',
  },
};
